<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  name: { type: String, required: true },
  value: { type: [String, Number], default: null },
  currency: { type: String, default: '' },
  expectedCloseDate: { type: String, default: null },
  manualProbability: { type: Number, default: null },
});

defineEmits(['click']);

const { t } = useI18n();
const formattedValue = () => {
  if (props.value === null || props.value === undefined || props.value === '')
    return '';
  const number = Number(props.value);
  if (Number.isNaN(number)) return '';
  return `${props.currency || ''} ${number.toLocaleString()}`.trim();
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-3 bg-n-solid-2 border border-n-weak rounded-lg cursor-pointer hover:border-n-slate-6 transition-colors"
    @click="$emit('click')"
  >
    <span class="text-sm font-medium text-n-slate-12 truncate">
      {{ name }}
    </span>
    <span v-if="formattedValue()" class="text-xs font-semibold text-n-blue-11">
      {{ formattedValue() }}
    </span>
    <div class="flex items-center justify-between text-xs text-n-slate-11">
      <span v-if="expectedCloseDate">{{ expectedCloseDate }}</span>
      <span v-if="manualProbability !== null">
        {{ t('OPPORTUNITIES.CARD.PROBABILITY', { value: manualProbability }) }}
      </span>
    </div>
  </div>
</template>
